var _toConsumableArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/toConsumableArray");

//Deduce a name and units from the remarks key
module.exports = function (rmrk) {
  var rx = /^struct: (.*)/; //Reject if not matching

  if (!rx.test(rmrk)) return {};
  var parenthesisRx = / ?\(.*?\)/g; //Remove parenthesis and fix known limitations to get a better result with headers later

  var broadString = rmrk.match(rx)[1].replace(/\) (.*)/g, '), $1');
  var name = "(".concat(broadString.replace(parenthesisRx, '').replace(/\bXYZ\b/, 'X, Y, Z'), ")"); //Replace commas inside parenthesis temporarily

  var commasRx = /(\([^)]*?),([^)]*?\))/g;

  while (broadString.match(commasRx)) {
    broadString = broadString.replace(commasRx, '$1:REPLACER:$2');
  }

  var broad = broadString.split(',');
  var units = [];
  var unitRx = /\((.+)\)/;
  broad.forEach(function (v) {
    if (!unitRx.test(v)) units.push('_');else {
      units.push.apply(units, _toConsumableArray(v.match(unitRx)[1].split(':REPLACER:')));
    }
  });
  return {
    name: name,
    units: units
  };
};